import type { Listing } from "./types";

// Helper for checking whether two users have at least one completed transaction together
export function haveCompletedTransaction(
  userA: string,
  userB: string,
  listings: Pick<Listing, "sellerId" | "buyerId" | "status">[]
): boolean {
  if (!userA || !userB || userA === userB) return false;

  return listings.some(
    (l) =>
      l.status === "sold" &&
      ((l.sellerId === userA && l.buyerId === userB) ||
        (l.sellerId === userB && l.buyerId === userA))
  );
}


